import { createStore } from 'effector';

export const $bins = createStore([]);

export const $ochvData = createStore({ count: 0, data: [] });

export const $tableControl = createStore({ page: 1, limit: 10 });
